import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerProfile } from '@/models';

@Component({
    name: 'CmgChipotleUAccountModalStudentProfile'
})

export default class CmgChipotleUAccountModalStudentProfile extends Vue {
    get isServiceOnline(): boolean {
        return !this.$appStore.state.reward.unreachable;
    }

    get isRewardsOnline(): boolean {
        return this.$appStore.state.featureFlags.orderingStatus?.isRewardsOnline ?? true;
    }

    get isRewardsExchangeOnline(): boolean {
        return this.$appStore.state.featureFlags.orderingStatus?.isRewardsExchangeOnline ?? true;
    }

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }

    get offlineMessage(): string {
        return `We're having some trouble getting your points.`;
    }

    get pointsBalance(): number {
        return this.$services.reward.getPointsBalance();
    }

    get studentCardImage(): string {
        return this.$appStore.state.cms.images.loyalty.studentCard.default;
    }

    get verifiedBadgeImage(): string {
        return this.$appStore.state.cms.images.loyalty.verifiedBadge.default;
    }

    get chipotleULogo(): string {
        return this.$appStore.state.cms.images.loyalty.chipotleULogo.default;
    }

    get customer(): CustomerProfile | null {
        const profile = this.$appStore.state.customer.profile;
        return profile && !profile.isGuest ? profile : null;
    }

    get studentGraduationDate(): string {
        if (this.customer?.student?.graduationDate) {
            const dateString = this.customer.student.graduationDate;
            const year = dateString.split('-')[0];
            return year;
        }
        return '';
    }

    get isNameLong(): boolean {
        return this.studentFirstName.length > 12 || this.studentLastName.length > 12;
    }

    get studentFirstName(): string {
        return this.customer?.displayFirstName || this.customer?.firstName || '';
    }

    get studentLastName(): string {
        return this.customer?.displayLastName || this.customer?.lastName || '';
    }
}